import React from 'react'
import { TooltipRenderProps } from 'react-joyride'

import { useI18n } from 'builder/hooks/useI18n'
import { JoyRideButtonProps } from 'builder/components/JoyRide/types'

import { SkipButton } from '../SkipButton/SkipButton'
import * as Styles from './styles'

interface IProps {
  skipButtonLabel: string
  nextButtonLabel: string
  finalButtonLabel: string
  isStepsCountEnabled?: boolean
  showSkipOnLast?: boolean
  nextButtonProps?: JoyRideButtonProps
  skipButtonProps?: JoyRideButtonProps
  onNext: (
    e: React.MouseEvent<HTMLElement>,
    callback: (e: React.MouseEvent<HTMLElement>) => void,
  ) => void
}

export const Tooltip: React.FC<TooltipRenderProps & IProps> = ({
  step,
  size,
  index,
  isLastStep,
  skipProps,
  closeProps,
  primaryProps,
  tooltipProps,
  skipButtonLabel,
  nextButtonLabel,
  finalButtonLabel,
  isStepsCountEnabled = true,
  nextButtonProps,
  skipButtonProps,
  onNext,
}) => {
  const { i18n } = useI18n()

  return (
    <>
      <Styles.TooltipBody
        className="tooltip__body"
        {...tooltipProps}
        style={{ ...step.styles.tooltipContainer, textAlign: 'start' }}
        data-testid="joyride-tooltip"
      >
        <Styles.TooltipContent>
          {step.title && (
            <Styles.TooltipTitle className="tooltip__title">{step.title}</Styles.TooltipTitle>
          )}
          <Styles.TooltipSubHeader className="tooltip__content">
            {step.content}
          </Styles.TooltipSubHeader>
        </Styles.TooltipContent>
        <Styles.TooltipFooter className="tooltip__footer">
          {isStepsCountEnabled && (
            <Styles.ProgressBarContainer>
              <Styles.Steps>
                {index + 1} {i18n.t('builder.dashboard_v2.steps.progress.of')} {size}
              </Styles.Steps>
              <Styles.ProgressContainer>
                <Styles.ProgressBar progress={((index + 1) / size) * 100} />
              </Styles.ProgressContainer>
            </Styles.ProgressBarContainer>
          )}
          <Styles.Actions>
            {!isLastStep && (
              <Styles.NextButton
                {...nextButtonProps}
                {...primaryProps}
                onClick={e => onNext(e, primaryProps.onClick)}
                data-testid="next-button"
              >
                {nextButtonLabel}
              </Styles.NextButton>
            )}
            {isLastStep && (
              <Styles.NextButton
                {...nextButtonProps}
                {...closeProps}
                onClick={e => onNext(e, closeProps.onClick)}
                data-testid="final-button"
              >
                {finalButtonLabel}
              </Styles.NextButton>
            )}
          </Styles.Actions>
        </Styles.TooltipFooter>
      </Styles.TooltipBody>
      <SkipButton
        skipProps={skipProps}
        skipButtonProps={skipButtonProps}
        skipButtonLabel={skipButtonLabel}
      />
    </>
  )
}
